// extracted by mini-css-extract-plugin
module.exports = {"radioList":"Detail_radioList_1DJMO","radio":"Detail_radio_1AcKm","error":"Detail_error_3OJ4Q"};